import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import "lenis/dist/lenis.css";
import { Toaster } from "@/components/ui/sonner";
import { StoreProvider } from "@/context/StoreContext";
import { Navbar } from "@/components/Navbar";
import { BasketDrawer } from "@/components/BasketDrawer";
import HomePage from "@/pages/HomePage";
import StorePage from "@/pages/StorePage";
import UltiPlusPage from "@/pages/UltiPlusPage";
import FlashSalePage from "@/pages/FlashSalePage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import ResetPassword from "@/pages/ResetPassword";
import LoginPage from "@/pages/LoginPage";
import AccountPage from "@/pages/AccountPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09 }}>
      <StoreProvider>
        <BrowserRouter>
          <div className="grain min-h-screen bg-[#05030A] text-slate-50">
            <Navbar />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/store" element={<StorePage />} />
              <Route path="/store/ulti" element={<UltiPlusPage />} />
              <Route path="/store/:category" element={<StorePage />} />
              <Route path="/flash-sale" element={<FlashSalePage />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/login" element={<AccountPage />} />
              <Route path="/account" element={<LoginPage />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
            <BasketDrawer />
            <Toaster theme="dark" position="bottom-right" />
          </div>
        </BrowserRouter>
      </StoreProvider>
    </ReactLenis>
  );
}

export default App;
